<template>
  <div @click.stop="click" class="row-menu">
    <!-- <i v-show="HasIconItem" class="icon-item" :class="iconItem" style="display:none"></i> -->
    <span v-show="!fontIcon && HasIconItem && iconItem != '3'" class="icon-item"
      >{{ iconItem }}

      <slot></slot>
    </span>
    <span
      v-show="!fontIcon && HasIconItem && iconItem == '3'"
      class="font-icon check-icon"
      >A</span
    >
    <span v-show="fontIcon" class="icon-item spec font-icon">{{
      iconItem
    }}</span>
    <div
      class="row-title"
      :class="{
        active: HasIconCheckbox && displayCheckbox,
        disable: HasIconCheckbox && !displayCheckbox,
        padd: HasIconCheckbox,
      }"
    >
      {{ title }}
    </div>
    <!-- <i v-show="HasIconArrow" class="fa fa-angle-left left-icon"></i> -->
    <baseIcon
      class="left-icon"
      nameIcon="arrow-next"
      pathIcon="icons-ganeral"
      width="7"
      height="10"
      v-show="HasIconArrow"
    />
    <!-- <i v-show="HasIconDisplay" :class="iconDisplay"></i> -->
    <button class="display-button font" v-show="HasIconDisplay">
      {{ buttonName }}
    </button>
    <baseToggleSwitch
      @toggle="$emit('toggle', $event)"
      @click.self.stop
      class="left-icon"
      :checked="displayCheckbox"
      v-show="HasIconCheckbox"
    />
  </div>
</template>

<script>
export default {
  name: "RowItem",
  props: {
    title: String,
    iconItem: String,
    iconDisplay: String,
    type: String,
    buttonName: String,
    HasIconItem: Boolean,
    HasIconArrow: Boolean,
    HasIconDisplay: Boolean,
    displayCheckbox: Boolean,
    HasIconCheckbox: Boolean,
    fontIcon: Boolean,
  },
  methods: {
    goBack() {
      this.$router.push({ name: this.routeBackName });
    },
    goToHomePage() {
      this.$router.push({ name: "home" });
    },
    click() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss">
.row-menu {
  margin: 0;
  padding: 0 20px 0 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // height: 30px;
  cursor: pointer;
  width: 100%;
}
// .icon-item {
// }
.row-in-menu {
  padding: 0 20px 0 20px;
}
.padd {
  padding-right: 8px;
  white-space: pre-wrap !important;
}
.row-title {
  // margin: 0px 10px 0px 10px;

  flex: auto;
  white-space: nowrap;
  .left-icon {
    padding: 10px 0;
    height: 36px;

    .switch {
    }
  }
  &.active {
    color: var(--custom-color1);
  }
}
// .left-icon {
// }
.display-button {
  border: 1px solid #c6c6c6;
  border-radius: 12px;
  cursor: pointer;
  margin: 2px;
  padding: 0;
  width: 76px;
  height: 24px;
  line-height: 23px;
  font-size: 14px;
  &:hover {
    background-color: #00000014;
  }
}
.icon-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
.spec {
  font-size: 30px;
  color: gray;
  padding-left: 5px;
  padding-right: 5px;
  font-family: otzar-new !important;
}
</style>
